import { render, staticRenderFns } from "./EggIcon.vue?vue&type=template&id=39d22261&scoped=true&"
import script from "./EggIcon.vue?vue&type=script&lang=js&"
export * from "./EggIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d22261",
  null
  
)

export default component.exports